/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FinancialAggregatedNumber = "accruedDeferred" | "actualCost" | "actualLockedRevenue" | "actualMargin" | "actualOpenRevenue" | "actualProfit" | "actualRevenue" | "actualRevenueMargin" | "actualRevenueProfit" | "allActualTimeAndExpenses" | "allForecastTimeAndExpensesToComplete" | "allPlannedTimeAndExpenses" | "allTotalTimeAndExpensesAtCompletion" | "allocationMinutes" | "baselineCost" | "baselineMargin" | "baselineMinutes" | "baselineProfit" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualMargin" | "baselineVsActualProfit" | "baselineVsActualRevenue" | "baselineVsActualRevenueMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueRecognition" | "baselineVsAllActualValueOfService" | "baselineVsAllProjectedValueOfService" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsForecastCost" | "baselineVsForecastMinutes" | "baselineVsForecastProfit" | "baselineVsForecastRevenue" | "baselineVsRegisteredMinutes" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalTimeAtCompletion" | "billableActualMinutes" | "billableActualTimeAndExpenses" | "billableForecastTimeAndExpensesToComplete" | "billablePlannedTimeAndExpenses" | "billableTime" | "billableTotalTimeAndExpensesAtCompletion" | "estimatedCost" | "estimatedCostPercentage" | "estimatedVsAllActualValueOfService" | "estimatedVsAllProjectedValueOfService" | "expenseCostPercentage" | "expenseRevenuePercentage" | "forecastCost" | "forecastCostToComplete" | "forecastLockedRevenueToComplete" | "forecastMargin" | "forecastMarginToComplete" | "forecastMinutes" | "forecastOpenRevenueToComplete" | "forecastProfit" | "forecastProfitToComplete" | "forecastRevenue" | "forecastRevenueMarginToComplete" | "forecastRevenueProfitToComplete" | "forecastTimeToComplete" | "forecastVsScopeApprovedMinutes" | "invoiced" | "nonBillableActualMinutes" | "nonBillableActualTimeAndExpenses" | "nonBillableForecastTimeAndExpensesToComplete" | "nonBillablePlannedTimeAndExpenses" | "nonBillableTotalTimeAndExpensesAtCompletion" | "paid" | "planVsActualCost" | "planVsActualMargin" | "planVsActualProfit" | "planVsActualRevenue" | "planVsActualRevenueMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsForecastCost" | "planVsForecastProfit" | "planVsForecastRevenue" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "plannedCost" | "plannedMargin" | "plannedProfit" | "plannedRevenue" | "plannedRevenueMargin" | "plannedRevenueProfit" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionAmount" | "recognitionForecastRevenue" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionLockedRevenue" | "recognitionOpenRevenue" | "recognitionPercentage" | "recognitionProfit" | "recognitionProfitPercentage" | "registeredMinutes" | "registeredVsScopeApprovedMinutes" | "remainingCost" | "remainingMargin" | "remainingMinutes" | "remainingProfit" | "remainingRevenue" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "scopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsRegisteredMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "scopeTotalMinutes" | "suggestedProfit" | "suggestedProfitPercentage" | "suggestedRevenue" | "suggestedRevenuePercentage" | "surplus" | "surplusPercentage" | "totalActualRevenueRecognition" | "totalCostAtCompletion" | "totalForecastRevenueToComplete" | "totalMarginAtCompletion" | "totalProfitAtCompletion" | "totalRevenueMarginAtCompletion" | "totalRevenueProfitAtCompletion" | "totalRevenueRecognition" | "totalTimeAtCompletion" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "INVOICES" | "LABELS" | "PEOPLE" | "PLACEHOLDERS" | "PROJECTS" | "RESOURCES" | "SKILLS" | "TASKS" | "TIME_REGS" | "%future added value";
export type GLOBAL_FILTER_FIELD = "APPROVAL_STATUS" | "ASSIGNED" | "ASSIGNED_SELF" | "BILLABLE" | "BILLABLE_TIME_REG" | "BILL_FROM" | "BILL_TO" | "BLOCKED" | "BUG" | "CLIENT" | "CLIENT_GUEST_USERS" | "CLIENT_TIME_REG" | "COMPANY_TASK_ID" | "CONTACT" | "CREATED_AT" | "DEADLINE" | "DEPARTMENT" | "DEPARTMENT_TIME_REG" | "DEPENDENCIES" | "DESCRIPTION" | "END_DATE" | "END_DATE_PROJECT" | "END_DATE_TIME_REG" | "FILTER_BY_TIME_REG_SETTINGS" | "FOLLOWER" | "FORECAST" | "HIGH_PRIORITY" | "INTERNAL_TIME" | "INTERNAL_TIME_REG" | "INVOICED" | "LABELS" | "LABEL_TIME_REG" | "NAME" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "NON_TASK_TIME_REG" | "NO_CONTACT" | "OWNER" | "PERMISSION_LEVEL" | "PERSON" | "PERSON_TIME_REG" | "PHASE_CATEGORY" | "PHASE_TIME_REG" | "PRIORITY_LEVEL" | "PROGRAM" | "PROJECT" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "PROJECT_FOLLOWER" | "PROJECT_GROUP" | "PROJECT_GROUP_SPRINT" | "PROJECT_GROUP_STATUS" | "PROJECT_LABELS" | "PROJECT_MANUAL_PROGRESS" | "PROJECT_OWNER" | "PROJECT_PERSON" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_STAGE" | "PROJECT_STATUS" | "PROJECT_TIME_REG" | "PROJECT_WIN_CHANCE" | "RATE_CARD" | "RECENT_ACTIVITY" | "RECENT_TASK_ACTIVITY" | "RECENT_TIME" | "REMAINING" | "RETAINER_PERIOD" | "ROLE" | "ROLE_TIME_REG" | "SET_DONE_AT" | "SKILL" | "SPRINT_CATEGORY" | "SPRINT_TIME_REG" | "STARRED" | "START_DATE" | "START_DATE_PROJECT" | "START_DATE_TIME_REG" | "STATUS" | "SUB_TASKS" | "TASK" | "TASK_APPROVED" | "TASK_HIERARCHY" | "TASK_LEVEL" | "TASK_TIME_REG" | "TEAM" | "TEAM_MEMBER" | "TEAM_TIME_REG" | "TIME_OFF" | "TIME_OFF_TIME_REG" | "TIME_REGS" | "UPDATED_AT" | "WITH_TASKS" | "WITH_TIME_REG" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "ALL_IN" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "IN" | "IS" | "IS_ALL" | "IS_NOT" | "IS_NOT_ALL" | "LESS" | "LESS_OR_EQUAL" | "NOT_ALL_IN" | "NOT_IN" | "%future added value";
export type TaskSearchQueryType = {
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
};
export type GlobalSearchFilterType = {
    field?: GLOBAL_FILTER_FIELD | null | undefined;
    operator?: GLOBAL_FILTER_OPERATOR | null | undefined;
    value?: Array<string | null> | null | undefined;
    context?: GLOBAL_FILTER_CONTEXT | null | undefined;
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
    logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null | undefined;
};
export type MonthByMonthClientLoader_QueryVariables = {
    startYear: number;
    startMonth: number;
    startDay: number;
    endYear: number;
    endMonth: number;
    endDay: number;
    searchQuery: TaskSearchQueryType;
    timeSearchQuery: TaskSearchQueryType;
    expenseSearchQuery: TaskSearchQueryType;
    selectedSingleValue: FinancialAggregatedNumber;
    ignoreBaselineWinChance?: boolean | null | undefined;
    excludeOpportunityActuals?: boolean | null | undefined;
};
export type MonthByMonthClientLoader_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"MonthByMonthClientLoader_viewer">;
    } | null;
};
export type MonthByMonthClientLoader_Query = {
    readonly response: MonthByMonthClientLoader_QueryResponse;
    readonly variables: MonthByMonthClientLoader_QueryVariables;
};



/*
query MonthByMonthClientLoader_Query(
  $startYear: Int!
  $startMonth: Int!
  $startDay: Int!
  $endYear: Int!
  $endMonth: Int!
  $endDay: Int!
  $searchQuery: TaskSearchQueryType!
  $timeSearchQuery: TaskSearchQueryType!
  $expenseSearchQuery: TaskSearchQueryType!
  $selectedSingleValue: FinancialAggregatedNumber!
  $ignoreBaselineWinChance: Boolean
  $excludeOpportunityActuals: Boolean
) {
  viewer {
    actualPersonId
    component(name: "project_portfolio_month_by_month_client_loader")
    ...MonthByMonthClientLoader_viewer_3H0CLP
    id
  }
}

fragment MonthByMonthClientLoader_viewer_3H0CLP on Viewer {
  id
  company {
    currency
    financialBasedClients(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals) {
      edges {
        node {
          id
          name
          aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)
          timeAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $timeSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)
          expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $expenseSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDay",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endDay",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchQuery",
    "type": "TaskSearchQueryType!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timeSearchQuery",
    "type": "TaskSearchQueryType!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "expenseSearchQuery",
    "type": "TaskSearchQueryType!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedSingleValue",
    "type": "FinancialAggregatedNumber!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ignoreBaselineWinChance",
    "type": "Boolean"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeOpportunityActuals",
    "type": "Boolean"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_portfolio_month_by_month_client_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"project_portfolio_month_by_month_client_loader\")"
},
v3 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v4 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v5 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v6 = {
  "kind": "Variable",
  "name": "excludeOpportunityActuals",
  "variableName": "excludeOpportunityActuals"
},
v7 = {
  "kind": "Variable",
  "name": "ignoreBaselineWinChance",
  "variableName": "ignoreBaselineWinChance"
},
v8 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v9 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v10 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v11 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "kind": "Literal",
  "name": "aggregateLevel",
  "value": "MONTH"
},
v14 = {
  "items": [
    {
      "kind": "Variable",
      "name": "aggregates.0",
      "variableName": "selectedSingleValue"
    }
  ],
  "kind": "ListValue",
  "name": "aggregates"
},
v15 = {
  "kind": "Literal",
  "name": "fetchOwnData",
  "value": true
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MonthByMonthClientLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "expenseSearchQuery",
                "variableName": "expenseSearchQuery"
              },
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "selectedSingleValue",
                "variableName": "selectedSingleValue"
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "kind": "Variable",
                "name": "timeSearchQuery",
                "variableName": "timeSearchQuery"
              }
            ],
            "kind": "FragmentSpread",
            "name": "MonthByMonthClientLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MonthByMonthClientLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "concreteType": "ClientTypeConnection",
                "kind": "LinkedField",
                "name": "financialBasedClients",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "aggregatedFinancialNumbers",
                            "storageKey": null
                          },
                          {
                            "alias": "timeAggregatedFinancialNumbers",
                            "args": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v15/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "searchQuery",
                                "variableName": "timeSearchQuery"
                              },
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "aggregatedFinancialNumbers",
                            "storageKey": null
                          },
                          {
                            "alias": "expenseAggregatedFinancialNumbers",
                            "args": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v15/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "searchQuery",
                                "variableName": "expenseSearchQuery"
                              },
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "aggregatedFinancialNumbers",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "MonthByMonthClientLoader_Query",
    "operationKind": "query",
    "text": "query MonthByMonthClientLoader_Query(\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n  $searchQuery: TaskSearchQueryType!\n  $timeSearchQuery: TaskSearchQueryType!\n  $expenseSearchQuery: TaskSearchQueryType!\n  $selectedSingleValue: FinancialAggregatedNumber!\n  $ignoreBaselineWinChance: Boolean\n  $excludeOpportunityActuals: Boolean\n) {\n  viewer {\n    actualPersonId\n    component(name: \"project_portfolio_month_by_month_client_loader\")\n    ...MonthByMonthClientLoader_viewer_3H0CLP\n    id\n  }\n}\n\nfragment MonthByMonthClientLoader_viewer_3H0CLP on Viewer {\n  id\n  company {\n    currency\n    financialBasedClients(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals) {\n      edges {\n        node {\n          id\n          name\n          aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)\n          timeAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $timeSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)\n          expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $expenseSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '2348e22c924019a6b59e52532c5b9d0f';
export default node;
